import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

export type LotterySlug = "mega-sena" | "lotofacil" | "quina" | "dupla-sena";

export const LOTTERIES: { slug: LotterySlug; name: string; short: string; min: number; max: number; pick: number; minPick: number; maxPick: number; color: string }[] = [
  // Limites min/max de dezenas por aposta conforme regras oficiais da Caixa.
  { slug: "mega-sena",  name: "Mega Sena",  short: "Mega",     min: 1, max: 60, pick: 6,  minPick: 6,  maxPick: 20, color: "hsl(var(--lt-teal))" },
  { slug: "lotofacil",  name: "Lotofácil",  short: "Lotofácil", min: 1, max: 25, pick: 15, minPick: 15, maxPick: 20, color: "hsl(var(--lt-purple))" },
  { slug: "quina",      name: "Quina",      short: "Quina",    min: 1, max: 80, pick: 5,  minPick: 5,  maxPick: 15, color: "hsl(var(--lt-gold))" },
  { slug: "dupla-sena", name: "Dupla Sena", short: "Dupla",    min: 1, max: 50, pick: 6,  minPick: 6,  maxPick: 15, color: "hsl(var(--accent))" },
];

interface Ctx {
  selected: LotterySlug;
  setSelected: (s: LotterySlug) => void;
  config: typeof LOTTERIES[number];
}

const LotteryCtx = createContext<Ctx | undefined>(undefined);

export function LotteryProvider({ children }: { children: ReactNode }) {
  const [selected, setSelectedState] = useState<LotterySlug>(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("lt-lottery") : null;
    return (stored as LotterySlug) || "mega-sena";
  });

  useEffect(() => {
    localStorage.setItem("lt-lottery", selected);
  }, [selected]);

  const config = LOTTERIES.find((l) => l.slug === selected) ?? LOTTERIES[0];

  return (
    <LotteryCtx.Provider value={{ selected, setSelected: setSelectedState, config }}>
      {children}
    </LotteryCtx.Provider>
  );
}

export function useLottery() {
  const ctx = useContext(LotteryCtx);
  if (!ctx) throw new Error("useLottery must be used within LotteryProvider");
  return ctx;
}
